import React from 'react';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import PhoneIcon from '@mui/icons-material/Phone';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { useNavigate } from 'react-router-dom';
import CheckIcon from '@mui/icons-material/Check';
import axios from 'axios';
import { toast } from 'react-toastify';
import useStore from '../../../Store/Store';

export default function Main() {
  const history = useNavigate();
  const user = useStore((state) => state.user);
  const width = useStore((state) => state.screenWidth);

  let phoneNo = '+1 456 7853456';

  const [isCopied, setIsCopied] = React.useState(false);

  const handleClickCopy = () => {
    navigator.clipboard.writeText(phoneNo);
    setIsCopied(true);
  };

  React.useEffect(() => {
    let id = null;
    if (isCopied) {
      id = setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    }

    return () => clearTimeout(id);
  }, [isCopied]);

  const handleClickEmergency = async () => {
    try {
      const userId = user?._id || user?.id;
      await axios.post(
        process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${userId}/emergencyAlarm`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            authorization: localStorage.getItem('auth'),
          },
        },
      );
      toast.success('Emergency alert added!');
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Something went wrong!');
    } finally {
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: '352px',
        padding: '24px 24px 24px 24px',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexWrap: 'nowrap',
        backgroundColor: '#00796b',
        borderRadius: '20px',
        position: 'relative',
        overflow: 'hidden',
        marginLeft: width > 550 ? '20px' : '0px',
      }}
      className="main-container top-margin-card"
    >
      <div
        style={{
          display: 'flex',
          minWidth: '0',
          flexDirection: 'column',
          gap: '8px',
          alignItems: 'flex-start',
          alignSelf: 'stretch',
          flexShrink: '0',
          flexWrap: 'nowrap',
          position: 'relative',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            alignSelf: 'stretch',
            flexShrink: '0',
            flexWrap: 'nowrap',
            position: 'relative',
            zIndex: '1',
          }}
        >
          <span
            style={{
              height: '28px',
              flexShrink: '0',
              flexBasis: 'auto',
              fontFamily: 'Roboto, var(--default-font-family)',
              fontSize: '20px',
              fontWeight: '500',
              lineHeight: '28px',
              color: '#ffffff',
              position: 'relative',
              textAlign: 'left',
              whiteSpace: 'nowrap',
              zIndex: '2',
            }}
          >
            CAN Emergency
          </span>
          <div
            style={{
              display: 'flex',
              width: '32px',
              height: '32px',
              padding: '7.996px 12px 7.996px 12px',
              gap: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              flexShrink: '0',
              flexWrap: 'nowrap',
              borderRadius: '100px',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              position: 'relative',
              zIndex: '3',
              cursor: 'pointer',
            }}
            onClick={() => history('/can-emergency')}
          >
            <div
              style={{
                width: '16px',
                height: '16px',
                flexShrink: '0',
                position: 'relative',
                zIndex: '4',
                color: '#fff',
              }}
            >
              <ArrowOutwardIcon fontSize="14px" />
            </div>
          </div>
        </div>
        <span
          style={{
            display: 'flex',
            width: 'auto',
            height: '66px',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            flexShrink: '0',
            fontFamily: 'Roboto, var(--default-font-family)',
            fontSize: '14px',
            fontWeight: '400',
            lineHeight: '22px',
            color: '#b0d5d1',
            position: 'relative',
            textAlign: 'left',
            zIndex: '6',
          }}
        >
          An operational agent is available 24/7 and service options are available. In order to contact the emergency
          services, you can call the number
        </span>
      </div>
      <div
        style={{
          display: 'flex',
          minWidth: '0',
          flexDirection: 'column',
          gap: '12px',
          alignItems: 'flex-start',
          alignSelf: 'stretch',
          flexShrink: '0',
          flexWrap: 'nowrap',
          position: 'relative',
          zIndex: '7',
        }}
      >
        {/* <div
          style={{
            display: 'flex',
            padding: '12px 16px 12px 16px',
            justifyContent: 'space-between',
            alignItems: 'center',
            alignSelf: 'stretch',
            flexShrink: '0',
            flexWrap: 'nowrap',
            backgroundColor: '#048778',
            borderRadius: '12px',
            position: 'relative',
            zIndex: '8',
          }}
        >
          <div
            style={{
              display: 'flex',
              width: '90px',
              gap: '12px',
              alignItems: 'center',
              flexShrink: '0',
              flexWrap: 'nowrap',
              position: 'relative',
              zIndex: '9',
            }}
          >
            <div
              style={{
                width: '8px',
                height: '8px',
                flexShrink: '0',
                backgroundPosition: 'center',
                backgroundImage: 'url(/images/6026dad0-6275-43f2-92b6-45c66218bff7.png)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                borderRadius: '50%',
                position: 'relative',
                zIndex: '10',
              }}
            />
            <span
              style={{
                height: '22px',
                flexShrink: '0',
                flexBasis: 'auto',
                fontFamily: 'Roboto, var(--default-font-family)',
                fontSize: '14px',
                fontWeight: '500',
                lineHeight: '22px',
                color: '#ffffff',
                position: 'relative',
                textAlign: 'left',
                whiteSpace: 'nowrap',
                zIndex: '11',
              }}
            >
              Active with
            </span>
          </div>
          <button
            style={{
              display: 'flex',
              width: '116px',
              height: '32px',
              padding: '4px 12px 4px 12px',
              gap: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              flexShrink: '0',
              flexWrap: 'nowrap',
              backgroundColor: '#ffffff',
              borderRadius: '100px',
              border: 'none',
              position: 'relative',
              zIndex: '12',
              cursor: 'pointer',
            }}
          >
            <span
              style={{
                height: '22px',
                flexShrink: '0',
                flexBasis: 'auto',
                fontFamily: 'Roboto, var(--default-font-family)',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '22px',
                color: '#1d1d1f',
                position: 'relative',
                textAlign: 'left',
                whiteSpace: 'nowrap',
                zIndex: '13',
              }}
            >
              Peter’s Can Go
            </span>
          </button>
        </div> */}
        <div
          style={{
            display: 'flex',
            padding: '12px 12px 12px 12px',
            justifyContent: 'space-between',
            alignItems: 'center',
            alignSelf: 'stretch',
            flexShrink: '0',
            flexWrap: 'nowrap',
            backgroundColor: '#048778',
            borderRadius: '12px',
            position: 'relative',
            zIndex: '14',
          }}
        >
          <div
            style={{
              display: 'flex',
              width: '94px',
              gap: '8px',
              alignItems: 'center',
              flexShrink: '0',
              flexWrap: 'nowrap',
              position: 'relative',
              zIndex: '15',
            }}
          >
            <div
              style={{
                width: '16px',
                height: '16px',
                flexShrink: '0',
                position: 'relative',
                zIndex: '16',
                color: '#fff',
              }}
            >
              <PhoneIcon fontSize="15px" />
            </div>
            <span
              style={{
                height: '22px',
                flexShrink: '0',
                flexBasis: 'auto',
                fontFamily: 'Roboto, var(--default-font-family)',
                fontSize: width > 1350 ? '14px' : '11px',
                fontWeight: '500',
                lineHeight: '22px',
                color: '#ffffff',
                position: 'relative',
                textAlign: 'left',
                whiteSpace: 'nowrap',
                zIndex: '18',
              }}
            >
              Emergency
            </span>
          </div>
          <button
            style={{
              display: 'flex',
              width: width > 1350 ? '146px' : '110px',
              height: '32px',
              padding: '4px 12px 4px 12px',
              gap: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              flexShrink: '0',
              flexWrap: 'nowrap',
              backgroundColor: '#ffffff',
              borderRadius: '100px',
              border: 'none',
              position: 'relative',
              zIndex: '19',
              cursor: 'pointer',
            }}
            onClick={handleClickCopy}
          >
            <span
              style={{
                height: '22px',
                flexShrink: '0',
                flexBasis: 'auto',
                fontFamily: 'Roboto, var(--default-font-family)',
                fontSize: width > 1350 ? '14px' : '11px',
                fontWeight: '400',
                lineHeight: '22px',
                color: '#1d1d1f',
                position: 'relative',
                textAlign: 'left',
                whiteSpace: 'nowrap',
                zIndex: '20',
              }}
            >
              {phoneNo}
            </span>
            <div
              style={{
                width: '16px',
                height: '16px',
                flexShrink: '0',
                position: 'relative',
                zIndex: '21',
              }}
            >
              {isCopied ? (
                <CheckIcon fontSize="15px" style={{ color: 'greenn' }} />
              ) : (
                <ContentCopyIcon fontSize="15px" />
              )}
            </div>
          </button>
        </div>
        <button
          style={{
            display: 'flex',
            height: '40px',
            padding: '7.996px 16px 7.996px 16px',
            gap: '8px',
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'stretch',
            flexShrink: '0',
            flexWrap: 'nowrap',
            backgroundColor: '#ffffff',
            borderRadius: '100px',
            border: 'none',
            position: 'relative',
            zIndex: '23',
            cursor: 'pointer',
          }}
          onClick={handleClickEmergency}
        >
          <div
            style={{
              width: '20px',
              height: '20px',
              flexShrink: '0',
              position: 'relative',
              zIndex: '24',
            }}
          >
            <PlayCircleIcon />
          </div>
          <span
            style={{
              height: '22px',
              flexShrink: '0',
              flexBasis: 'auto',
              fontFamily: 'Roboto, var(--default-font-family)',
              fontSize: width > 1350 ? '14px' : '11px',
              fontWeight: '500',
              lineHeight: '22px',
              color: '#1d1d1f',
              position: 'relative',
              textAlign: 'left',
              whiteSpace: 'nowrap',
              zIndex: '26',
            }}
          >
            Activate emergency response
          </span>
        </button>
      </div>
    </div>
  );
}
